import React from 'react';
import { TFunction } from "react-i18next";
import styles from './ContactInfoCard.module.scss';
import { CompanyPage } from '../../../../../../hooks/slices/companySlice'; // Adjusted
import { EmailIcon, PhoneIcon, WebsiteIcon } from '../../../../../../components/icons'; // Adjusted
import { IconWithLink } from '../../../../../../components/iconWithLink'; // Adjusted
import { IconWithTextAndCopyButton } from '../../../../../../components/iconWithTextAndCopyButton'; // Adjusted

interface ContactInfoCardProps {
    companyPage: CompanyPage;
    t: TFunction;
}

export const ContactInfoCard: React.FC<ContactInfoCardProps> = (props) => {
    const phone: string | undefined = props.companyPage.phone;
    const email: string | undefined = props.companyPage.email;
    const website: string | undefined = props.companyPage.website;
    const headerText: string = props.t("companyPage.company_info_contact_title");

    return (<div className={styles["info-card"]}>
        <h1>{headerText}</h1>
        {phone && <IconWithTextAndCopyButton icon={<PhoneIcon/>} text={phone}/>}
        {email && <IconWithTextAndCopyButton icon={<EmailIcon/>} text={email}/>}
        {website && <IconWithLink icon={<WebsiteIcon/>} text={website}/>}
    </div>)
} 